export const formatValueAsCurrency = (value: number, currency?: string, locale?: string) => {
  return new Intl.NumberFormat(locale || 'en-US', {
    style: 'currency',
    currency: currency || 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
};

export const formatValueAsNumber = (value: number, locale?: string) => {
  if (!value) {
    return `0`;
  } else {
    return `${value.toLocaleString(locale || 'en-US', { maximumFractionDigits: 2 })}`;
  }
};

export function formatValueAsPercent(num: number): string {
  return `${formatValueAsNumber(num)}%`;
};

export type FormatValueOptions = "currency" | "number" | "percent";

export const formatValue = (value: any, formatAs?: FormatValueOptions, currency?: string) => {
  const isNumber = typeof value === "number";
  if (!isNumber) {
    return value;
  }
  switch (formatAs) {
    case "currency":
      return formatValueAsCurrency(value, currency);
    case "number":
      return formatValueAsNumber(value);
    case "percent":
      return formatValueAsPercent(value);
    default:
      return value;
  }
};

export const formatNumberAsMinAndHours = (num: number): string => {
  const numRounded = Math.floor(num);

  const hours = Math.floor(numRounded / 60);
  const mins = numRounded % 60;

  let formattedTime = "";

  if (hours > 0 && mins > 0) {
    formattedTime = `${hours}hr ${mins}m`;
  } else if (hours > 0) {
    formattedTime = `${hours}hr`;
  } else {
    // no hours, just minutes
    formattedTime = `${mins}m`;
  }

  return formattedTime;
};

export function formatValueToAbbreviatedNumber(number: number, asCurrency: boolean = false, decPlaces: number = 2) {
  // 2 decimal places => 100, 3 => 1000, etc
  decPlaces = Math.pow(10, decPlaces);
  let abbrvNumber: number | string = number;

  // Enumerate number abbreviations
  var abbrev = ["k", "m", "b", "t"];

  // Go through the array backwards, so we do the largest first
  for (var i = abbrev.length - 1; i >= 0; i--) {

    // Convert array index to "1000", "1000000", etc
    var size = Math.pow(10, (i + 1) * 3);

    // If the number is bigger or equal do the abbreviation
    if (size <= abbrvNumber) {
      // Here, we multiply by decPlaces, round, and then divide by decPlaces.
      // This gives us nice rounding to a particular decimal place.
      abbrvNumber = Math.round(abbrvNumber * decPlaces / size) / decPlaces;

      // Handle special case where we round up to the next abbreviation
      if ((abbrvNumber == 1000) && (i < abbrev.length - 1)) {
        abbrvNumber = 1;
        i++;
      }

      abbrvNumber = asCurrency ? formatValueAsCurrency(abbrvNumber) : abbrvNumber;

      // Add the letter for the abbreviation
      abbrvNumber = `${abbrvNumber}${abbrev[i]}`;

      // We are done... stop
      break;
    }
  }
  if (typeof abbrvNumber === "number") {
    abbrvNumber = asCurrency ? formatValueAsCurrency(abbrvNumber) : abbrvNumber;
  }

  return abbrvNumber;
};
